
export default Object.freeze({
  NONE: Symbol('none'),
  TEMPLATE: Symbol('template'),
  UPLOAD: Symbol('upload'),
  TOOLPATH: Symbol('toolpath'),
  TOOLPATH_ONLY: Symbol('toolpath_only'),
  BRAND: Symbol('brand'),

  PLUGIN_PREVIEW: Symbol('plugin_preview'),
  PLUGIN_TOOLPATH: Symbol('plugin_toolpath'),
  PLUGIN_NESTING: Symbol('plugin_nesting')
});



// WEBPACK FOOTER //
// ./src/assets/javascripts/misc/Modes.js